export const calculateClockOrderList = (points) => {
  const pointPairs = [];
  for (let i = 0; i < points.length; i += 2) {
    pointPairs.push({ x: points[i], y: points[i + 1] });
  }
  const centroid = pointPairs.reduce(
    (acc, point) => {
      acc.x += point.x;
      acc.y += point.y;
      return acc;
    },
    { x: 0, y: 0 }
  );
  centroid.x /= pointPairs.length;
  centroid.y /= pointPairs.length;
  pointPairs.forEach((point) => {
    const angle = Math.atan2(point.y - centroid.y, point.x - centroid.x);
    point.angle = angle;
  });
  pointPairs.sort((a, b) => b.angle - a.angle);
  const sortedPoints = [];
  pointPairs.forEach((point) => {
    sortedPoints.push(point.x, point.y);
  });
  return sortedPoints;
};
